import { BrowserRouter, Route, Routes } from "react-router-dom";
import RouteScrollToTop from "./helper/RouteScrollToTop";
import ScrollToTop from "react-scroll-to-top";
import AboutPage from "./pages/AboutPage";
import ServicePage from "./pages/ServicePage";
import ServiceDetailsPage from "./pages/ServiceDetailsPage";
import ContactPage from "./pages/ContactPage";
import HomePageTwo from "./pages/HomePageTwo";
import { createContext } from "react";
import "react-loading-skeleton/dist/skeleton.css";
import ShowRoomPage from "./pages/ShowRoomPage";
import CarDetailsPage from "./pages/CarDetailsPage";
import Parts from "./pages/Parts";
import CarSell from "./pages/CarSell";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import SelectService from "./pages/SelectService";
import Booking from "./pages/Booking";
import Terms from "./pages/Terms";
import PrivacyPolicy from "./pages/PrivacyPolicy";

export const GlobalInfo = createContext();
function App() {
  return (
    <BrowserRouter>
      <RouteScrollToTop />
      <ScrollToTop smooth color="#E8092E" />
      <GlobalInfo.Provider>
        <Routes>
          <Route exact path="/" element={<HomePageTwo />} />
          <Route exact path="/car-details/:id" element={<CarDetailsPage />} />
          <Route exact path="/about" element={<AboutPage />} />
          <Route exact path="/all-services" element={<ServicePage />} />
          <Route exact path="/select-service/:service-name" element={<SelectService />} />
          <Route
            exact
            path="/service-details"
            element={<ServiceDetailsPage />}
          />
          <Route exact path="/contact" element={<ContactPage />} />
          <Route exact path="/showroom" element={<ShowRoomPage />} />
          <Route exact path="/sell-car" element={<CarSell />} />
          <Route exact path="/part-exchange" element={<Parts />} />
          <Route exact path="/booking/:service-name" element={<Booking />} />
          <Route exact path="/Terms-and-condition" element={<Terms />} />
          <Route exact path="/privacy-policy" element={<PrivacyPolicy />} />
        </Routes>
      </GlobalInfo.Provider>
    </BrowserRouter>
  );
}

export default App;
